import isArrayLike from './is-array-like';
export default function head(o) {
    if (isArrayLike(o)) {
        return o[0];
    }
    return undefined;
}
//# sourceMappingURL=head.js.map


//////////////////
// WEBPACK FOOTER
// ./~/@antv/util/esm/head.js
// module id = 481
// module chunks = 3